exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".login-popup .forms-wrapper{max-width:480px;padding:0}", ""]);

